// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Chip,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Paper,
//   Grid,
//   Card,
//   CardContent,
//   Alert,
//   CircularProgress,
//   AppBar,
//   Toolbar,
//   Fab,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TableSortLabel,
//   Tabs,
//   Tab,
//   Stepper,
//   Step,
//   StepLabel,
//   Avatar,
//   Divider,
// } from "@mui/material";
// import {
//   Add as AddIcon,
//   Edit as EditIcon,
//   Delete as DeleteIcon,
//   Visibility as ViewIcon,
//   Close as CloseIcon,
//   Favorite as ReproductionIcon,
//   FilterList as FilterIcon,
//   Search as SearchIcon,
//   Timeline as TimelineIcon,
//   PregnantWoman as PregnancyIcon,
//   // Insemination as BiotechIcon,
//   LocalOffer as TagIcon,
//   CalendarToday as CalendarIcon,
//   Description as NotesIcon,
//   Pets as AnimalIcon,
//   Category as EventTypeIcon,
// } from "@mui/icons-material";
// import BiotechIcon from '@mui/icons-material/Biotech';
// import { TableVirtuoso } from "react-virtuoso";
// import { useNavigate } from "react-router-dom";
// import swal from "sweetalert";

// // Virtualized Table Components
// const VirtuosoTableComponents = {
//   Scroller: React.forwardRef((props, ref) => (
//     <TableContainer component={Paper} {...props} ref={ref} />
//   )),
//   Table: (props) => (
//     <Table
//       {...props}
//       sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
//     />
//   ),
//   TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
//   TableRow: (props) => <TableRow {...props} />,
//   TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
// };

// const ReproductionEventsPage = () => {
//   const navigate = useNavigate();
//   const [reproductionEvents, setReproductionEvents] = useState([]);
//   const [filteredEvents, setFilteredEvents] = useState([]);
//   const [loading, setLoading] = useState(false);
  
//   // Filters and Search
//   const [searchTerm, setSearchTerm] = useState("");
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
//   const [filters, setFilters] = useState({
//     event_type: "",
//     animal_id: "",
//     date_range: ""
//   });

//   // Tabs for event types
//   const [activeTab, setActiveTab] = useState(0);

//   // Dialogs
//   const [showFilters, setShowFilters] = useState(false);
//   const [openCreateDialog, setOpenCreateDialog] = useState(false);
//   const [openEditDialog, setOpenEditDialog] = useState(false);
//   const [openViewDialog, setOpenViewDialog] = useState(false);
//   const [selectedEvent, setSelectedEvent] = useState(null);

//   // Form Data
//   const [reproductionForm, setReproductionForm] = useState({
//     animal_id: "",
//     event_type: "Heat",
//     date: new Date().toISOString().split('T')[0],
//     notes: ""
//   });

//   const [animals, setAnimals] = useState([]);

//   const API_URL = "https://dairy.server.statify.co.ke/api/reproduction-events";

//   // Table Columns for Virtualized Table
//   const columns = [
//     { width: 120, label: 'Animal ID', dataKey: 'animal_id' },
//     { width: 150, label: 'Animal Name', dataKey: 'animal_name' },
//     { width: 150, label: 'Event Type', dataKey: 'event_type' },
//     { width: 120, label: 'Event Date', dataKey: 'date' },
//     { width: 200, label: 'Notes', dataKey: 'notes' },
//     { width: 120, label: 'Status', dataKey: 'status' },
//     { width: 200, label: 'Actions', dataKey: 'actions' },
//   ];

//   // Event Type Options
//   const eventTypeOptions = ["Heat", "Insemination", "Pregnancy Check"];
  
//   // Date Range Options
//   const dateRangeOptions = [
//     "Last 7 days",
//     "Last 30 days", 
//     "Last 90 days",
//     "This year"
//   ];

//   // Helper function to format date for form input
//   const formatDateForInput = (dateString) => {
//     if (!dateString) return new Date().toISOString().split('T')[0];
    
//     try {
//       const date = new Date(dateString);
      
//       if (isNaN(date.getTime())) {
//         console.warn('Invalid date:', dateString);
//         return new Date().toISOString().split('T')[0];
//       }
      
//       return date.toISOString().split('T')[0];
//     } catch (error) {
//       console.error('Error formatting date:', error, dateString);
//       return new Date().toISOString().split('T')[0];
//     }
//   };

//   // Fetch only cows (animals with animal_class = 'Cow')
//   const fetchCows = async () => {
//     try {
//       const res = await fetch("https://dairy.server.statify.co.ke/api/animals");
//       const data = await res.json();
      
//       let animalsList = [];
      
//       if (data.animals && Array.isArray(data.animals)) {
//         animalsList = data.animals;
//       } else if (Array.isArray(data)) {
//         animalsList = data;
//       } else if (data.data && Array.isArray(data.data)) {
//         animalsList = data.data;
//       }
      
//       // Filter only cows (animals with animal_class = 'Cow')
//       const cowsOnly = animalsList.filter(animal => 
//         animal.animal_class === 'Cow' || 
//         animal.animal_class === 'cow' ||
//         (animal.species === 'Cattle' && animal.sex === 'Female')
//       );
      
//       console.log('Filtered cows for reproduction:', cowsOnly);
//       setAnimals(cowsOnly);
//     } catch (err) {
//       console.error('Error fetching cows:', err);
//       swal("Error", "Failed to fetch cows", "error");
//     }
//   };

//   // Fetch Reproduction Events
//   const fetchReproductionEvents = async () => {
//     setLoading(true);
//     try {
//       const res = await fetch(API_URL);
//       const data = await res.json();
      
//       if (Array.isArray(data)) {
//         // Transform data to include animal names and status
//         const transformedEvents = await Promise.all(
//           data.map(async (event) => {
//             let animalName = "Unknown";
//             let animalTag = "Unknown";
//             try {
//               // Fetch animal details to get the name
//               const animalRes = await fetch(`https://dairy.server.statify.co.ke/api/animals/${event.animal_id}`);
//               if (animalRes.ok) {
//                 const animalData = await animalRes.json();
//                 animalName = animalData.name || `Animal ${event.animal_id}`;
//                 animalTag = animalData.tag_number || `Tag ${event.animal_id}`;
//               }
//             } catch (err) {
//               console.error('Error fetching animal details:', err);
//             }

//             // Format date for display
//             let displayDate = "Invalid Date";
//             try {
//               const date = new Date(event.date);
//               if (!isNaN(date.getTime())) {
//                 displayDate = date.toLocaleDateString();
//               }
//             } catch (err) {
//               console.error('Error formatting display date:', err);
//             }

//             return {
//               ...event,
//               animal_name: animalName,
//               animal_tag: animalTag,
//               status: getEventStatus(event.event_type),
//               date: displayDate,
//               short_notes: event.notes ? 
//                 (event.notes.length > 50 ? `${event.notes.substring(0, 50)}...` : event.notes) 
//                 : 'No notes',
//               originalDate: event.date // Keep original date for editing
//             };
//           })
//         );
//         setReproductionEvents(transformedEvents);
//       } else {
//         setReproductionEvents([]);
//       }
//     } catch (err) {
//       console.error('Error fetching reproduction events:', err);
//       swal("Error", "Failed to fetch reproduction events", "error");
//       setReproductionEvents([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchReproductionEvents();
//     fetchCows(); // Changed from fetchAnimals to fetchCows
//   }, []);

//   // Filter events based on search, filters, and active tab
//   useEffect(() => {
//     if (!Array.isArray(reproductionEvents)) {
//       setFilteredEvents([]);
//       return;
//     }
    
//     let results = reproductionEvents;

//     // Apply tab filter
//     if (activeTab > 0) {
//       const eventType = eventTypeOptions[activeTab - 1];
//       results = results.filter(event => event.event_type === eventType);
//     }

//     // Apply search term
//     if (searchTerm) {
//       results = results.filter(event =>
//         (event.animal_name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (event.animal_tag?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (event.notes?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (event.event_type?.toLowerCase() || '').includes(searchTerm.toLowerCase())
//       );
//     }

//     // Apply event type filter
//     if (filters.event_type) {
//       results = results.filter(event => 
//         event.event_type === filters.event_type
//       );
//     }

//     // Apply animal filter
//     if (filters.animal_id) {
//       results = results.filter(event => 
//         event.animal_id.toString() === filters.animal_id
//       );
//     }

//     // Apply date range filter
//     if (filters.date_range) {
//       const now = new Date();
//       let startDate = new Date();
      
//       switch (filters.date_range) {
//         case "Last 7 days":
//           startDate.setDate(now.getDate() - 7);
//           break;
//         case "Last 30 days":
//           startDate.setDate(now.getDate() - 30);
//           break;
//         case "Last 90 days":
//           startDate.setDate(now.getDate() - 90);
//           break;
//         case "This year":
//           startDate = new Date(now.getFullYear(), 0, 1);
//           break;
//         default:
//           break;
//       }
      
//       results = results.filter(event => {
//         try {
//           const eventDate = new Date(event.originalDate || event.date);
//           return !isNaN(eventDate.getTime()) && eventDate >= startDate;
//         } catch (err) {
//           console.error('Error filtering by date:', err);
//           return false;
//         }
//       });
//     }

//     // Apply sorting
//     if (sortConfig.key) {
//       results.sort((a, b) => {
//         const aVal = a[sortConfig.key];
//         const bVal = b[sortConfig.key];
        
//         if (aVal === null || aVal === undefined) return 1;
//         if (bVal === null || bVal === undefined) return -1;
        
//         if (sortConfig.key === 'date') {
//           // Sort by date object for proper date comparison
//           try {
//             const aDate = new Date(a.originalDate || a.date);
//             const bDate = new Date(b.originalDate || b.date);
//             if (isNaN(aDate.getTime()) || isNaN(bDate.getTime())) return 0;
//             return sortConfig.direction === 'asc' ? aDate - bDate : bDate - aDate;
//           } catch (err) {
//             return 0;
//           }
//         }
        
//         if (typeof aVal === 'string' && typeof bVal === 'string') {
//           return sortConfig.direction === 'asc' 
//             ? aVal.localeCompare(bVal)
//             : bVal.localeCompare(aVal);
//         }
        
//         if (aVal < bVal) {
//           return sortConfig.direction === 'asc' ? -1 : 1;
//         }
//         if (aVal > bVal) {
//           return sortConfig.direction === 'asc' ? 1 : -1;
//         }
//         return 0;
//       });
//     }

//     setFilteredEvents(results);
//   }, [reproductionEvents, searchTerm, filters, sortConfig, activeTab]);

//   // Sort Handler
//   const handleSort = (key) => {
//     let direction = 'asc';
//     if (sortConfig.key === key && sortConfig.direction === 'asc') {
//       direction = 'desc';
//     }
//     setSortConfig({ key, direction });
//   };

//   // Filter Handlers
//   const handleFilterChange = (key, value) => {
//     setFilters(prev => ({
//       ...prev,
//       [key]: value
//     }));
//   };

//   const resetFilters = () => {
//     setFilters({
//       event_type: "",
//       animal_id: "",
//       date_range: ""
//     });
//     setSearchTerm("");
//     setSortConfig({ key: null, direction: 'asc' });
//     setActiveTab(0);
//   };

//   // Form Handlers
//   const handleFormChange = (field, value) => {
//     setReproductionForm(prev => ({
//       ...prev,
//       [field]: value
//     }));
//   };

//   const resetForm = () => {
//     setReproductionForm({
//       animal_id: "",
//       event_type: "Heat",
//       date: new Date().toISOString().split('T')[0],
//       notes: ""
//     });
//   };

//   // Get Event Status
//   const getEventStatus = (eventType) => {
//     switch (eventType) {
//       case "Heat": return "Cycle";
//       case "Insemination": return "Breeding";
//       case "Pregnancy Check": return "Check";
//       default: return "Recorded";
//     }
//   };

//   // Create Reproduction Event
//   const handleCreateReproductionEvent = async () => {
//     // Validation
//     if (!reproductionForm.animal_id || !reproductionForm.event_type) {
//       swal("Error", "Animal and event type are required", "error");
//       return;
//     }

//     try {
//       const res = await fetch(API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           ...reproductionForm,
//           animal_id: parseInt(reproductionForm.animal_id)
//         }),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         swal("Success", "Reproduction event recorded successfully!", "success");
//         setOpenCreateDialog(false);
//         resetForm();
//         fetchReproductionEvents();
//       } else {
//         swal("Error", data.error, "error");
//       }
//     } catch (err) {
//       swal("Error", "Something went wrong", "error");
//     }
//   };

//   // Update Reproduction Event
//   const handleUpdateReproductionEvent = async () => {
//     if (!selectedEvent) return;

//     try {
//       const res = await fetch(`${API_URL}/${selectedEvent.id}`, {
//         method: "PUT",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           ...reproductionForm,
//           animal_id: parseInt(reproductionForm.animal_id)
//         }),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         swal("Success", "Reproduction event updated successfully!", "success");
//         setOpenEditDialog(false);
//         setSelectedEvent(null);
//         resetForm();
//         fetchReproductionEvents();
//       } else {
//         swal("Error", data.error, "error");
//       }
//     } catch (err) {
//       swal("Error", "Something went wrong", "error");
//     }
//   };

//   // Delete Handler
//   const handleDelete = async (eventId) => {
//     const confirm = await swal({
//       title: "Are you sure?",
//       text: "This will permanently delete the reproduction event!",
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     });

//     if (confirm) {
//       try {
//         const res = await fetch(`${API_URL}/${eventId}`, { method: "DELETE" });
//         const data = await res.json();
//         if (res.ok) {
//           swal("Deleted!", data.message, "success");
//           fetchReproductionEvents();
//         } else {
//           swal("Error", data.error, "error");
//         }
//       } catch (err) {
//         swal("Error", "Something went wrong", "error");
//       }
//     }
//   };

//   // View Handler
//   const handleView = (event) => {
//     setSelectedEvent(event);
//     setOpenViewDialog(true);
//   };

//   // Open Edit Dialog - FIXED VERSION
//   const handleEdit = (event) => {
//     setSelectedEvent(event);
    
//     // Use the helper function to safely format the date
//     const formattedDate = formatDateForInput(event.originalDate || event.date);
    
//     setReproductionForm({
//       animal_id: event.animal_id.toString(),
//       event_type: event.event_type,
//       date: formattedDate,
//       notes: event.notes || ""
//     });
//     setOpenEditDialog(true);
//   };

//   // Get Event Type Color
//   const getEventTypeColor = (eventType) => {
//     switch (eventType) {
//       case "Heat": return 'warning';
//       case "Insemination": return 'primary';
//       case "Pregnancy Check": return 'success';
//       default: return 'default';
//     }
//   };

//   // Get Event Type Icon
//   const getEventTypeIcon = (eventType) => {
//     switch (eventType) {
//       case "Heat": return "🔥";
//       case "Insemination": return "🔬";
//       case "Pregnancy Check": return "🤰";
//       default: return "📝";
//     }
//   };

//   // Get Event Type MUI Icon
//   const getEventTypeMuiIcon = (eventType) => {
//     switch (eventType) {
//       case "Heat": return <ReproductionIcon />;
//       case "Insemination": return <BiotechIcon />;
//       case "Pregnancy Check": return <PregnancyIcon />;
//       default: return <EventTypeIcon />;
//     }
//   };

//   // Tab Change Handler
//   const handleTabChange = (event, newValue) => {
//     setActiveTab(newValue);
//   };

//   // Virtualized Table Content
//   const fixedHeaderContent = () => (
//     <TableRow>
//       {columns.map((column) => (
//         <TableCell
//           key={column.dataKey}
//           variant="head"
//           align="left"
//           style={{ width: column.width }}
//           sx={{ 
//             backgroundColor: 'secondary.main', 
//             color: 'white',
//             fontWeight: 'bold',
//             fontSize: '14px',
//             padding: '12px 8px'
//           }}
//         >
//           <TableSortLabel
//             active={sortConfig.key === column.dataKey}
//             direction={sortConfig.direction}
//             onClick={() => handleSort(column.dataKey)}
//             sx={{ color: 'white !important' }}
//           >
//             {column.label}
//           </TableSortLabel>
//         </TableCell>
//       ))}
//     </TableRow>
//   );

//   const rowContent = (index, event) => (
//     <React.Fragment>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" fontWeight="bold" noWrap>
//           {event.animal_id}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Box>
//           <Typography variant="body2" fontWeight="bold" noWrap>
//             {event.animal_name}
//           </Typography>
//           <Typography variant="caption" color="textSecondary" noWrap>
//             Tag: {event.animal_tag}
//           </Typography>
//         </Box>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Chip 
//           label={`${getEventTypeIcon(event.event_type)} ${event.event_type}`} 
//           size="small"
//           color={getEventTypeColor(event.event_type)}
//           sx={{ fontSize: '0.7rem', height: '24px' }}
//         />
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {event.date}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap title={event.notes}>
//           {event.short_notes}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Chip 
//           label={event.status} 
//           size="small"
//           color={getEventTypeColor(event.event_type)}
//           variant="outlined"
//           sx={{ fontSize: '0.7rem', height: '24px' }}
//         />
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'nowrap' }}>
//           <IconButton 
//             size="small" 
//             color="info"
//             onClick={() => handleView(event)}
//             sx={{ 
//               minWidth: '32px', 
//               width: '32px', 
//               height: '32px',
//               backgroundColor: 'rgba(2, 136, 209, 0.1)',
//               color: 'info.main',
//               border: '1px solid',
//               borderColor: 'info.light',
//               '&:hover': { 
//                 backgroundColor: 'info.main',
//                 color: 'white'
//               }
//             }}
//           >
//             <ViewIcon fontSize="small" />
//           </IconButton>
//           <IconButton 
//             size="small" 
//             color="primary"
//             onClick={() => handleEdit(event)}
//             sx={{ 
//               minWidth: '32px', 
//               width: '32px', 
//               height: '32px',
//               backgroundColor: 'rgba(25, 118, 210, 0.1)',
//               color: 'primary.main',
//               border: '1px solid',
//               borderColor: 'primary.light',
//               '&:hover': { 
//                 backgroundColor: 'primary.main',
//                 color: 'white'
//               }
//             }}
//           >
//             <EditIcon fontSize="small" />
//           </IconButton>
//           <IconButton 
//             size="small" 
//             color="error"
//             onClick={() => handleDelete(event.id)}
//             sx={{ 
//               minWidth: '32px', 
//               width: '32px', 
//               height: '32px',
//               backgroundColor: 'rgba(211, 47, 47, 0.1)',
//               color: 'error.main',
//               border: '1px solid',
//               borderColor: 'error.light',
//               '&:hover': { 
//                 backgroundColor: 'error.main',
//                 color: 'white'
//               }
//             }}
//           >
//             <DeleteIcon fontSize="small" />
//           </IconButton>
//         </Box>
//       </TableCell>
//     </React.Fragment>
//   );

//   return (
//     <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
//       {/* Header */}
//       <AppBar position="static" elevation={2} sx={{ backgroundColor: 'secondary.dark' }}>
//         <Toolbar>
//           <ReproductionIcon sx={{ mr: 2, fontSize: 32 }} />
//           <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
//             Reproduction Events
//           </Typography>
//           <Chip 
//             label={`${reproductionEvents.length} Events`} 
//             color="primary" 
//             variant="filled"
//             sx={{ color: 'white', fontWeight: 'bold', mr: 2 }}
//           />
//           <Button 
//             variant="contained" 
//             startIcon={<AddIcon sx={{ fontSize: 24 }} />}
//             onClick={() => setOpenCreateDialog(true)}
//             sx={{ 
//               borderRadius: 2, 
//               backgroundColor: 'success.main',
//               '&:hover': {
//                 backgroundColor: 'success.dark',
//                 transform: 'translateY(-2px)',
//                 boxShadow: 4
//               },
//               transition: 'all 0.3s ease',
//               fontWeight: 'bold',
//               fontSize: '1rem',
//               px: 3,
//               py: 1.5
//             }}
//           >
//             New Event
//           </Button>
//         </Toolbar>
//       </AppBar>

//       {/* Main Content */}
//       <Box sx={{ p: 3 }}>
//         <Paper sx={{ mb: 3, borderRadius: 2, border: 2, borderColor: 'secondary.light' }}>
//           {/* Event Type Tabs */}
//           <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
//             <Tabs value={activeTab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto">
//               <Tab label="All Events" />
//               <Tab label="Heat" icon={<span>🔥</span>} iconPosition="start" />
//               <Tab label="Insemination" icon={<span>🔬</span>} iconPosition="start" />
//               <Tab label="Pregnancy Check" icon={<span>🤰</span>} iconPosition="start" />
//             </Tabs>
//           </Box>

//           {/* Search and Filters */}
//           <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
//             <Grid container spacing={2} alignItems="center">
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   placeholder="Search by cow name, tag, notes, event type..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   InputProps={{
//                     startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1, fontSize: 24 }} />,
//                   }}
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
//                   <Button
//                     startIcon={<FilterIcon sx={{ fontSize: 20 }} />}
//                     onClick={() => setShowFilters(!showFilters)}
//                     variant={showFilters ? "contained" : "outlined"}
//                     size="small"
//                     color="secondary"
//                     sx={{ borderRadius: 2 }}
//                   >
//                     Filters
//                   </Button>
//                   <Button 
//                     onClick={resetFilters} 
//                     variant="outlined" 
//                     size="small" 
//                     color="secondary"
//                     sx={{ borderRadius: 2 }}
//                   >
//                     Reset
//                   </Button>
//                   <Button 
//                     onClick={fetchReproductionEvents} 
//                     variant="contained" 
//                     size="small" 
//                     color="primary"
//                     startIcon={<TimelineIcon sx={{ fontSize: 20 }} />}
//                     sx={{ borderRadius: 2 }}
//                   >
//                     Refresh
//                   </Button>
//                 </Box>
//               </Grid>
//             </Grid>

//             {/* Expandable Filters */}
//             {showFilters && (
//               <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={6} md={4}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Event Type</InputLabel>
//                       <Select
//                         value={filters.event_type}
//                         onChange={(e) => handleFilterChange('event_type', e.target.value)}
//                         label="Event Type"
//                       >
//                         <MenuItem value="">All Event Types</MenuItem>
//                         {eventTypeOptions.map(type => (
//                           <MenuItem key={type} value={type}>
//                             {type}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} sm={6} md={4}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Cow</InputLabel>
//                       <Select
//                         value={filters.animal_id}
//                         onChange={(e) => handleFilterChange('animal_id', e.target.value)}
//                         label="Cow"
//                       >
//                         <MenuItem value="">All Cows</MenuItem>
//                         {animals.map(animal => (
//                           <MenuItem key={animal.id} value={animal.id.toString()}>
//                             {animal.name || `Cow ${animal.id}`} ({animal.tag_number})
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} sm={6} md={4}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Date Range</InputLabel>
//                       <Select
//                         value={filters.date_range}
//                         onChange={(e) => handleFilterChange('date_range', e.target.value)}
//                         label="Date Range"
//                       >
//                         <MenuItem value="">All Dates</MenuItem>
//                         {dateRangeOptions.map(range => (
//                           <MenuItem key={range} value={range}>
//                             {range}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                 </Grid>
//               </Box>
//             )}
//           </Box>

//           {/* Content Area */}
//           <Box sx={{ p: 2 }}>
//             {loading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
//                 <CircularProgress color="secondary" size={40} />
//               </Box>
//             ) : filteredEvents.length === 0 ? (
//               <Card sx={{ textAlign: 'center', p: 4, border: 2, borderColor: 'secondary.light' }}>
//                 <CardContent>
//                   <TimelineIcon sx={{ fontSize: 64, color: 'secondary.main', mb: 2 }} />
//                   <Typography variant="h5" color="secondary.main" gutterBottom>
//                     {animals.length === 0 ? "No Cows Available" : "No Reproduction Events Found"}
//                   </Typography>
//                   <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
//                     {animals.length === 0 
//                       ? "No cows found in the system. Please add cows first to record reproduction events."
//                       : "Start tracking your herd's reproduction cycle to optimize breeding and improve productivity"
//                     }
//                   </Typography>
//                   <Button 
//                     variant="contained" 
//                     color="secondary" 
//                     onClick={() => setOpenCreateDialog(true)} 
//                     size="large"
//                     startIcon={<AddIcon sx={{ fontSize: 24 }} />}
//                     sx={{ borderRadius: 2 }}
//                     disabled={animals.length === 0}
//                   >
//                     {animals.length === 0 ? "Add Cows First" : "Record First Event"}
//                   </Button>
//                 </CardContent>
//               </Card>
//             ) : (
//               <Paper elevation={0} sx={{ height: 600, border: 1, borderColor: 'secondary.light', borderRadius: 1 }}>
//                 <TableVirtuoso
//                   data={filteredEvents}
//                   components={VirtuosoTableComponents}
//                   fixedHeaderContent={fixedHeaderContent}
//                   itemContent={rowContent}
//                 />
//               </Paper>
//             )}
//           </Box>
//         </Paper>
//       </Box>

//       {/* Create Reproduction Event Dialog - REDESIGNED */}
//       <Dialog 
//         open={openCreateDialog} 
//         onClose={() => setOpenCreateDialog(false)}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{ 
//           sx: { 
//             borderRadius: 3,
//             background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
//             boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
//           } 
//         }}
//       >
//         <DialogTitle sx={{ 
//           backgroundColor: 'primary.main', 
//           color: 'white',
//           background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//           py: 3,
//           position: 'relative',
//           overflow: 'hidden'
//         }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative', zIndex: 1 }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//               <Avatar sx={{ backgroundColor: 'rgba(255,255,255,0.2)', width: 48, height: 48 }}>
//                 <AddIcon sx={{ fontSize: 28 }} />
//               </Avatar>
//               <Box>
//                 <Typography variant="h5" fontWeight="bold">
//                   Record New Reproduction Event
//                 </Typography>
//                 <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
//                   Track breeding cycles and reproductive health
//                 </Typography>
//               </Box>
//             </Box>
//             <IconButton 
//               onClick={() => setOpenCreateDialog(false)} 
//               sx={{ 
//                 color: 'white',
//                 backgroundColor: 'rgba(255,255,255,0.2)',
//                 '&:hover': { backgroundColor: 'rgba(255,255,255,0.3)' }
//               }}
//             >
//               <CloseIcon sx={{ fontSize: 24 }} />
//             </IconButton>
//           </Box>
//         </DialogTitle>

//         <DialogContent sx={{ p: 0 }}>
//           {/* Stepper for better UX */}
//           <Box sx={{ px: 4, pt: 3, pb: 2 }}>
//             <Stepper activeStep={0} alternativeLabel>
//               <Step>
//                 <StepLabel>Event Details</StepLabel>
//               </Step>
//               <Step>
//                 <StepLabel>Animal Selection</StepLabel>
//               </Step>
//               <Step>
//                 <StepLabel>Confirmation</StepLabel>
//               </Step>
//             </Stepper>
//           </Box>

//           <Divider />

//           <Box sx={{ p: 4 }}>
//             <Grid container spacing={4}>
//               {/* Animal Selection Section */}
//               <Grid item xs={12}>
//                 <Card variant="outlined" sx={{ borderRadius: 2, borderColor: 'primary.light', backgroundColor: 'rgba(25, 118, 210, 0.02)' }}>
//                   <CardContent sx={{ p: 3 }}>
//                     <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
//                       <AnimalIcon color="primary" sx={{ mr: 2, fontSize: 28 }} />
//                       <Typography variant="h6" color="primary" fontWeight="bold">
//                         Select Animal
//                       </Typography>
//                     </Box>
//                     <FormControl fullWidth size="large">
//                       <InputLabel id="animal-label" sx={{ fontWeight: 'bold' }}>
//                         🐄 Choose Cow *
//                       </InputLabel>
//                       <Select
//                         labelId="animal-label"
//                         value={reproductionForm.animal_id}
//                         onChange={(e) => handleFormChange('animal_id', e.target.value)}
//                         label="🐄 Choose Cow *"
//                         disabled={animals.length === 0}
//                         sx={{
//                           '& .MuiSelect-select': {
//                             py: 2.5,
//                             fontSize: '1rem'
//                           }
//                         }}
//                       >
//                         {animals.map(animal => (
//                           <MenuItem key={animal.id} value={animal.id.toString()} sx={{ py: 2 }}>
//                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
//                               <Avatar sx={{ backgroundColor: 'primary.main', width: 40, height: 40 }}>
//                                 <AnimalIcon sx={{ fontSize: 20 }} />
//                               </Avatar>
//                               <Box sx={{ flexGrow: 1 }}>
//                                 <Typography variant="body1" fontWeight="bold">
//                                   {animal.name || `Cow ${animal.id}`}
//                                 </Typography>
//                                 <Typography variant="body2" color="textSecondary">
//                                   <TagIcon sx={{ fontSize: 14, mr: 0.5 }} />
//                                   Tag: {animal.tag_number} • ID: {animal.id}
//                                 </Typography>
//                               </Box>
//                               {animal.breed && (
//                                 <Chip 
//                                   label={animal.breed} 
//                                   size="small" 
//                                   variant="outlined" 
//                                   color="secondary"
//                                 />
//                               )}
//                             </Box>
//                           </MenuItem>
//                         ))}
//                       </Select>
//                       {animals.length === 0 && (
//                         <Alert severity="warning" sx={{ mt: 2, borderRadius: 2 }}>
//                           <Typography fontWeight="bold">No cows available</Typography>
//                           Please add cows first to record reproduction events.
//                         </Alert>
//                       )}
//                     </FormControl>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               {/* Event Details Section */}
//               <Grid item xs={12}>
//                 <Card variant="outlined" sx={{ borderRadius: 2, borderColor: 'secondary.light', backgroundColor: 'rgba(156, 39, 176, 0.02)' }}>
//                   <CardContent sx={{ p: 3 }}>
//                     <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
//                       <EventTypeIcon color="secondary" sx={{ mr: 2, fontSize: 28 }} />
//                       <Typography variant="h6" color="secondary" fontWeight="bold">
//                         Event Details
//                       </Typography>
//                     </Box>
                    
//                     <Grid container spacing={3}>
//                       <Grid item xs={12} md={6}>
//                         <FormControl fullWidth size="large">
//                           <InputLabel id="event-type-label" sx={{ fontWeight: 'bold' }}>
//                             📋 Event Type *
//                           </InputLabel>
//                           <Select
//                             labelId="event-type-label"
//                             value={reproductionForm.event_type}
//                             onChange={(e) => handleFormChange('event_type', e.target.value)}
//                             label="📋 Event Type *"
//                             sx={{
//                               '& .MuiSelect-select': {
//                                 py: 2.5,
//                                 fontSize: '1rem'
//                               }
//                             }}
//                           >
//                             {eventTypeOptions.map(type => (
//                               <MenuItem key={type} value={type} sx={{ py: 2 }}>
//                                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                                   <Avatar 
//                                     sx={{ 
//                                       backgroundColor: getEventTypeColor(type) + '.main',
//                                       width: 36, 
//                                       height: 36 
//                                     }}
//                                   >
//                                     {getEventTypeMuiIcon(type)}
//                                   </Avatar>
//                                   <Box>
//                                     <Typography variant="body1" fontWeight="bold">
//                                       {type}
//                                     </Typography>
//                                     <Typography variant="caption" color="textSecondary">
//                                       {type === "Heat" && "Heat cycle detection"}
//                                       {type === "Insemination" && "Artificial insemination"}
//                                       {type === "Pregnancy Check" && "Pregnancy verification"}
//                                     </Typography>
//                                   </Box>
//                                 </Box>
//                               </MenuItem>
//                             ))}
//                           </Select>
//                         </FormControl>
//                       </Grid>

//                       <Grid item xs={12} md={6}>
//                         <TextField
//                           fullWidth
//                           size="large"
//                           label={
//                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                               <CalendarIcon color="action" />
//                               <span>Event Date *</span>
//                             </Box>
//                           }
//                           type="date"
//                           value={reproductionForm.date}
//                           onChange={(e) => handleFormChange('date', e.target.value)}
//                           InputLabelProps={{ shrink: true }}
//                           InputProps={{
//                             sx: {
//                               py: 2.5,
//                               fontSize: '1rem'
//                             }
//                           }}
//                         />
//                       </Grid>
//                     </Grid>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               {/* Notes Section */}
//               <Grid item xs={12}>
//                 <Card variant="outlined" sx={{ borderRadius: 2, borderColor: 'success.light', backgroundColor: 'rgba(76, 175, 80, 0.02)' }}>
//                   <CardContent sx={{ p: 3 }}>
//                     <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
//                       <NotesIcon color="success" sx={{ mr: 2, fontSize: 28 }} />
//                       <Typography variant="h6" color="success.main" fontWeight="bold">
//                         Additional Notes
//                       </Typography>
//                     </Box>
//                     <TextField
//                       fullWidth
//                       multiline
//                       rows={4}
//                       placeholder="📝 Record important observations, procedures performed, medications used, or any other relevant details about this reproduction event..."
//                       value={reproductionForm.notes}
//                       onChange={(e) => handleFormChange('notes', e.target.value)}
//                       helperText="Detailed notes help in tracking reproductive health and making informed breeding decisions"
//                       sx={{
//                         '& .MuiOutlinedInput-root': {
//                           fontSize: '1rem',
//                           lineHeight: 1.5
//                         }
//                       }}
//                     />
//                   </CardContent>
//                 </Card>
//               </Grid>
//             </Grid>
//           </Box>
//         </DialogContent>

//         <DialogActions sx={{ p: 4, pt: 2, gap: 2 }}>
//           <Button 
//             onClick={() => setOpenCreateDialog(false)} 
//             size="large"
//             variant="outlined"
//             sx={{ 
//               minWidth: 120,
//               borderRadius: 2,
//               py: 1.5,
//               borderWidth: 2,
//               '&:hover': { borderWidth: 2 }
//             }}
//           >
//             Cancel
//           </Button>
//           <Button 
//             onClick={handleCreateReproductionEvent} 
//             variant="contained" 
//             color="success"
//             size="large"
//             disabled={!reproductionForm.animal_id || !reproductionForm.event_type || animals.length === 0}
//             sx={{ 
//               minWidth: 180,
//               borderRadius: 2,
//               py: 1.5,
//               fontSize: '1.1rem',
//               fontWeight: 'bold',
//               background: 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
//               boxShadow: '0 4px 15px rgba(76, 175, 80, 0.3)',
//               '&:hover': {
//                 boxShadow: '0 6px 20px rgba(76, 175, 80, 0.4)',
//                 transform: 'translateY(-2px)'
//               },
//               transition: 'all 0.3s ease'
//             }}
//           >
//             <AddIcon sx={{ mr: 1, fontSize: 24 }} />
//             Record Event
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Edit Reproduction Event Dialog - REDESIGNED */}
//       <Dialog 
//         open={openEditDialog} 
//         onClose={() => setOpenEditDialog(false)}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{ 
//           sx: { 
//             borderRadius: 3,
//             background: 'linear-gradient(135deg, #fffde7 0%, #f5f7fa 100%)',
//             boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
//           } 
//         }}
//       >
//         <DialogTitle sx={{ 
//           backgroundColor: 'primary.main', 
//           color: 'white',
//           background: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)',
//           py: 3,
//           position: 'relative',
//           overflow: 'hidden'
//         }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative', zIndex: 1 }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//               <Avatar sx={{ backgroundColor: 'rgba(255,255,255,0.2)', width: 48, height: 48 }}>
//                 <EditIcon sx={{ fontSize: 28 }} />
//               </Avatar>
//               <Box>
//                 <Typography variant="h5" fontWeight="bold">
//                   Update Reproduction Event
//                 </Typography>
//                 <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
//                   Modify event details and notes
//                 </Typography>
//               </Box>
//             </Box>
//             <IconButton 
//               onClick={() => setOpenEditDialog(false)} 
//               sx={{ 
//                 color: 'white',
//                 backgroundColor: 'rgba(255,255,255,0.2)',
//                 '&:hover': { backgroundColor: 'rgba(255,255,255,0.3)' }
//               }}
//             >
//               <CloseIcon sx={{ fontSize: 24 }} />
//             </IconButton>
//           </Box>
//         </DialogTitle>

//         <DialogContent sx={{ p: 4 }}>
//           <Grid container spacing={4}>
//             {/* Animal Selection Section */}
//             <Grid item xs={12}>
//               <Card variant="outlined" sx={{ borderRadius: 2, borderColor: 'primary.light', backgroundColor: 'rgba(25, 118, 210, 0.02)' }}>
//                 <CardContent sx={{ p: 3 }}>
//                   <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
//                     <AnimalIcon color="primary" sx={{ mr: 2, fontSize: 28 }} />
//                     <Typography variant="h6" color="primary" fontWeight="bold">
//                       Animal Information
//                     </Typography>
//                   </Box>
//                   <FormControl fullWidth size="large">
//                     <InputLabel id="edit-animal-label" sx={{ fontWeight: 'bold' }}>
//                       🐄 Select Cow *
//                     </InputLabel>
//                     <Select
//                       labelId="edit-animal-label"
//                       value={reproductionForm.animal_id}
//                       onChange={(e) => handleFormChange('animal_id', e.target.value)}
//                       label="🐄 Select Cow *"
//                       sx={{
//                         '& .MuiSelect-select': {
//                           py: 2.5,
//                           fontSize: '1rem'
//                         }
//                       }}
//                     >
//                       {animals.map(animal => (
//                         <MenuItem key={animal.id} value={animal.id.toString()} sx={{ py: 2 }}>
//                           <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
//                             <Avatar sx={{ backgroundColor: 'primary.main', width: 40, height: 40 }}>
//                               <AnimalIcon sx={{ fontSize: 20 }} />
//                             </Avatar>
//                             <Box sx={{ flexGrow: 1 }}>
//                               <Typography variant="body1" fontWeight="bold">
//                                 {animal.name || `Cow ${animal.id}`}
//                               </Typography>
//                               <Typography variant="body2" color="textSecondary">
//                                 <TagIcon sx={{ fontSize: 14, mr: 0.5 }} />
//                                 Tag: {animal.tag_number} • ID: {animal.id}
//                               </Typography>
//                             </Box>
//                             {animal.breed && (
//                               <Chip 
//                                 label={animal.breed} 
//                                 size="small" 
//                                 variant="outlined" 
//                                 color="secondary"
//                               />
//                             )}
//                           </Box>
//                         </MenuItem>
//                       ))}
//                     </Select>
//                   </FormControl>
//                 </CardContent>
//               </Card>
//             </Grid>

//             {/* Event Details Section */}
//             <Grid item xs={12}>
//               <Card variant="outlined" sx={{ borderRadius: 2, borderColor: 'secondary.light', backgroundColor: 'rgba(156, 39, 176, 0.02)' }}>
//                 <CardContent sx={{ p: 3 }}>
//                   <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
//                     <EventTypeIcon color="secondary" sx={{ mr: 2, fontSize: 28 }} />
//                     <Typography variant="h6" color="secondary" fontWeight="bold">
//                       Event Details
//                     </Typography>
//                   </Box>
                  
//                   <Grid container spacing={3}>
//                     <Grid item xs={12} md={6}>
//                       <FormControl fullWidth size="large">
//                         <InputLabel id="edit-event-type-label" sx={{ fontWeight: 'bold' }}>
//                           📋 Event Type *
//                         </InputLabel>
//                         <Select
//                           labelId="edit-event-type-label"
//                           value={reproductionForm.event_type}
//                           onChange={(e) => handleFormChange('event_type', e.target.value)}
//                           label="📋 Event Type *"
//                           sx={{
//                             '& .MuiSelect-select': {
//                               py: 2.5,
//                               fontSize: '1rem'
//                             }
//                           }}
//                         >
//                           {eventTypeOptions.map(type => (
//                             <MenuItem key={type} value={type} sx={{ py: 2 }}>
//                               <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                                 <Avatar 
//                                   sx={{ 
//                                     backgroundColor: getEventTypeColor(type) + '.main',
//                                     width: 36, 
//                                     height: 36 
//                                   }}
//                                 >
//                                   {getEventTypeMuiIcon(type)}
//                                 </Avatar>
//                                 <Box>
//                                   <Typography variant="body1" fontWeight="bold">
//                                     {type}
//                                   </Typography>
//                                   <Typography variant="caption" color="textSecondary">
//                                     {type === "Heat" && "Heat cycle detection"}
//                                     {type === "Insemination" && "Artificial insemination"}
//                                     {type === "Pregnancy Check" && "Pregnancy verification"}
//                                   </Typography>
//                                 </Box>
//                               </Box>
//                             </MenuItem>
//                           ))}
//                         </Select>
//                       </FormControl>
//                     </Grid>

//                     <Grid item xs={12} md={6}>
//                       <TextField
//                         fullWidth
//                         size="large"
//                         label={
//                           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                             <CalendarIcon color="action" />
//                             <span>Event Date *</span>
//                           </Box>
//                         }
//                         type="date"
//                         value={reproductionForm.date}
//                         onChange={(e) => handleFormChange('date', e.target.value)}
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           sx: {
//                             py: 2.5,
//                             fontSize: '1rem'
//                           }
//                         }}
//                       />
//                     </Grid>
//                   </Grid>
//                 </CardContent>
//               </Card>
//             </Grid>

//             {/* Notes Section */}
//             <Grid item xs={12}>
//               <Card variant="outlined" sx={{ borderRadius: 2, borderColor: 'success.light', backgroundColor: 'rgba(76, 175, 80, 0.02)' }}>
//                 <CardContent sx={{ p: 3 }}>
//                   <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
//                     <NotesIcon color="success" sx={{ mr: 2, fontSize: 28 }} />
//                     <Typography variant="h6" color="success.main" fontWeight="bold">
//                       Additional Notes
//                     </Typography>
//                   </Box>
//                   <TextField
//                     fullWidth
//                     multiline
//                     rows={4}
//                     placeholder="📝 Update observations, procedures, medications, or any relevant details..."
//                     value={reproductionForm.notes}
//                     onChange={(e) => handleFormChange('notes', e.target.value)}
//                     helperText="Keep notes updated for accurate reproductive health tracking"
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         fontSize: '1rem',
//                         lineHeight: 1.5
//                       }
//                     }}
//                   />
//                 </CardContent>
//               </Card>
//             </Grid>
//           </Grid>
//         </DialogContent>

//         <DialogActions sx={{ p: 4, pt: 2, gap: 2 }}>
//           <Button 
//             onClick={() => setOpenEditDialog(false)} 
//             size="large"
//             variant="outlined"
//             sx={{ 
//               minWidth: 120,
//               borderRadius: 2,
//               py: 1.5,
//               borderWidth: 2,
//               '&:hover': { borderWidth: 2 }
//             }}
//           >
//             Cancel
//           </Button>
//           <Button 
//             onClick={handleUpdateReproductionEvent} 
//             variant="contained" 
//             color="primary"
//             size="large"
//             disabled={!reproductionForm.animal_id || !reproductionForm.event_type}
//             sx={{ 
//               minWidth: 200,
//               borderRadius: 2,
//               py: 1.5,
//               fontSize: '1.1rem',
//               fontWeight: 'bold',
//               background: 'linear-gradient(135deg, #2196F3 0%, #1976D2 100%)',
//               boxShadow: '0 4px 15px rgba(33, 150, 243, 0.3)',
//               '&:hover': {
//                 boxShadow: '0 6px 20px rgba(33, 150, 243, 0.4)',
//                 transform: 'translateY(-2px)'
//               },
//               transition: 'all 0.3s ease'
//             }}
//           >
//             <EditIcon sx={{ mr: 1, fontSize: 24 }} />
//             Update Event
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* View Reproduction Event Dialog */}
//       <Dialog 
//         open={openViewDialog} 
//         onClose={() => setOpenViewDialog(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//               <ViewIcon sx={{ mr: 1, fontSize: 28, color: 'info.main' }} />
//               <Typography variant="h6">Reproduction Event Details</Typography>
//             </Box>
//             <IconButton onClick={() => setOpenViewDialog(false)}>
//               <CloseIcon sx={{ fontSize: 24 }} />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           {selectedEvent && (
//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={6}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Animal Information
//                     </Typography>
//                     <Typography variant="body2" sx={{ mb: 1 }}>
//                       <strong>Animal ID:</strong> {selectedEvent.animal_id}
//                     </Typography>
//                     <Typography variant="body2" sx={{ mb: 1 }}>
//                       <strong>Animal Name:</strong> {selectedEvent.animal_name}
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Tag Number:</strong> {selectedEvent.animal_tag}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>
              
//               <Grid item xs={12} sm={6}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Event Details
//                     </Typography>
//                     <Typography variant="body2" sx={{ mb: 1 }}>
//                       <strong>Event Type:</strong> 
//                       <Chip 
//                         label={`${getEventTypeIcon(selectedEvent.event_type)} ${selectedEvent.event_type}`} 
//                         size="small"
//                         color={getEventTypeColor(selectedEvent.event_type)}
//                         sx={{ ml: 1 }}
//                       />
//                     </Typography>
//                     <Typography variant="body2" sx={{ mb: 1 }}>
//                       <strong>Date:</strong> {selectedEvent.date}
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Status:</strong> {selectedEvent.status}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               <Grid item xs={12}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Event Notes
//                     </Typography>
//                     <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
//                       {selectedEvent.notes || 'No notes recorded for this event.'}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>
//             </Grid>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenViewDialog(false)}>Close</Button>
//         </DialogActions>
//       </Dialog>

//       {/* Add FAB for mobile */}
//       <Fab
//         color="secondary"
//         aria-label="add"
//         sx={{
//           position: 'fixed',
//           bottom: 24,
//           right: 24,
//           display: { xs: 'flex', md: 'none' }
//         }}
//         onClick={() => setOpenCreateDialog(true)}
//         disabled={animals.length === 0}
//       >
//         <AddIcon />
//       </Fab>
//     </Box>
//   );
// };

// export default ReproductionEventsPage;

import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  Grid,
  Card,
  CardContent,
  Alert,
  CircularProgress,
  AppBar,
  Toolbar,
  Fab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Tabs,
  Tab,
  Stepper,
  Step,
  StepLabel,
  Avatar,
  Divider,
} from "@mui/material";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  Close as CloseIcon,
  Favorite as ReproductionIcon,
  FilterList as FilterIcon,
  Search as SearchIcon,
  Timeline as TimelineIcon,
  PregnantWoman as PregnancyIcon,
  LocalOffer as TagIcon,
  CalendarToday as CalendarIcon,
  Description as NotesIcon,
  Pets as AnimalIcon,
  Category as EventTypeIcon,
} from "@mui/icons-material";
import BiotechIcon from '@mui/icons-material/Biotech';
import { TableVirtuoso } from "react-virtuoso";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";

// Virtualized Table Components
const VirtuosoTableComponents = {
  Scroller: React.forwardRef((props, ref) => (
    <TableContainer component={Paper} {...props} ref={ref} />
  )),
  Table: (props) => (
    <Table
      {...props}
      sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
    />
  ),
  TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
  TableRow: (props) => <TableRow {...props} />,
  TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
};

const ReproductionEventsPage = () => {
  const navigate = useNavigate();
  const [reproductionEvents, setReproductionEvents] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  
  // Filters and Search
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [filters, setFilters] = useState({
    event_type: "",
    animal_id: "",
    date_range: ""
  });

  // Custom color theme
  const customColors = {
    primary: '#024A59', // Dark teal
    secondary: '#FFA916', // Orange
    lightTeal: '#e6f0f2',
    lightOrange: '#fff5e6'
  };

  // Tabs for event types
  const [activeTab, setActiveTab] = useState(0);

  // Dialogs
  const [showFilters, setShowFilters] = useState(false);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);

  // Form Data
  const [reproductionForm, setReproductionForm] = useState({
    animal_id: "",
    event_type: "Heat",
    date: new Date().toISOString().split('T')[0],
    notes: ""
  });

  const [animals, setAnimals] = useState([]);

  const API_URL = "https://dairy.server.statify.co.ke/api/reproduction-events";

  // Table Columns for Virtualized Table
  const columns = [
    { width: 120, label: 'Animal ID', dataKey: 'animal_id' },
    { width: 150, label: 'Animal Name', dataKey: 'animal_name' },
    { width: 150, label: 'Event Type', dataKey: 'event_type' },
    { width: 120, label: 'Event Date', dataKey: 'date' },
    { width: 200, label: 'Notes', dataKey: 'notes' },
    { width: 120, label: 'Status', dataKey: 'status' },
    { width: 200, label: 'Actions', dataKey: 'actions' },
  ];

  // Event Type Options
  const eventTypeOptions = ["Heat", "Insemination", "Pregnancy Check"];
  
  // Date Range Options
  const dateRangeOptions = [
    "Last 7 days",
    "Last 30 days", 
    "Last 90 days",
    "This year"
  ];

  // Helper function to format date for form input
  const formatDateForInput = (dateString) => {
    if (!dateString) return new Date().toISOString().split('T')[0];
    
    try {
      const date = new Date(dateString);
      
      if (isNaN(date.getTime())) {
        console.warn('Invalid date:', dateString);
        return new Date().toISOString().split('T')[0];
      }
      
      return date.toISOString().split('T')[0];
    } catch (error) {
      console.error('Error formatting date:', error, dateString);
      return new Date().toISOString().split('T')[0];
    }
  };

  // Fetch only cows (animals with animal_class = 'Cow')
  const fetchCows = async () => {
    try {
      const res = await fetch("https://dairy.server.statify.co.ke/api/animals");
      const data = await res.json();
      
      let animalsList = [];
      
      if (data.animals && Array.isArray(data.animals)) {
        animalsList = data.animals;
      } else if (Array.isArray(data)) {
        animalsList = data;
      } else if (data.data && Array.isArray(data.data)) {
        animalsList = data.data;
      }
      
      // Filter only cows (animals with animal_class = 'Cow')
      const cowsOnly = animalsList.filter(animal => 
        animal.animal_class === 'Cow' || 
        animal.animal_class === 'cow' ||
        (animal.species === 'Cattle' && animal.sex === 'Female')
      );
      
      console.log('Filtered cows for reproduction:', cowsOnly);
      setAnimals(cowsOnly);
    } catch (err) {
      console.error('Error fetching cows:', err);
      swal("Error", "Failed to fetch cows", "error");
    }
  };

  // Fetch Reproduction Events
  const fetchReproductionEvents = async () => {
    setLoading(true);
    try {
      const res = await fetch(API_URL);
      const data = await res.json();
      
      if (Array.isArray(data)) {
        // Transform data to include animal names and status
        const transformedEvents = await Promise.all(
          data.map(async (event) => {
            let animalName = "Unknown";
            let animalTag = "Unknown";
            try {
              // Fetch animal details to get the name
              const animalRes = await fetch(`https://dairy.server.statify.co.ke/api/animals/${event.animal_id}`);
              if (animalRes.ok) {
                const animalData = await animalRes.json();
                animalName = animalData.name || `Animal ${event.animal_id}`;
                animalTag = animalData.tag_number || `Tag ${event.animal_id}`;
              }
            } catch (err) {
              console.error('Error fetching animal details:', err);
            }

            // Format date for display
            let displayDate = "Invalid Date";
            try {
              const date = new Date(event.date);
              if (!isNaN(date.getTime())) {
                displayDate = date.toLocaleDateString();
              }
            } catch (err) {
              console.error('Error formatting display date:', err);
            }

            return {
              ...event,
              animal_name: animalName,
              animal_tag: animalTag,
              status: getEventStatus(event.event_type),
              date: displayDate,
              short_notes: event.notes ? 
                (event.notes.length > 50 ? `${event.notes.substring(0, 50)}...` : event.notes) 
                : 'No notes',
              originalDate: event.date // Keep original date for editing
            };
          })
        );
        setReproductionEvents(transformedEvents);
      } else {
        setReproductionEvents([]);
      }
    } catch (err) {
      console.error('Error fetching reproduction events:', err);
      swal("Error", "Failed to fetch reproduction events", "error");
      setReproductionEvents([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReproductionEvents();
    fetchCows(); // Changed from fetchAnimals to fetchCows
  }, []);

  // Filter events based on search, filters, and active tab
  useEffect(() => {
    if (!Array.isArray(reproductionEvents)) {
      setFilteredEvents([]);
      return;
    }
    
    let results = reproductionEvents;

    // Apply tab filter
    if (activeTab > 0) {
      const eventType = eventTypeOptions[activeTab - 1];
      results = results.filter(event => event.event_type === eventType);
    }

    // Apply search term
    if (searchTerm) {
      results = results.filter(event =>
        (event.animal_name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (event.animal_tag?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (event.notes?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (event.event_type?.toLowerCase() || '').includes(searchTerm.toLowerCase())
      );
    }

    // Apply event type filter
    if (filters.event_type) {
      results = results.filter(event => 
        event.event_type === filters.event_type
      );
    }

    // Apply animal filter
    if (filters.animal_id) {
      results = results.filter(event => 
        event.animal_id.toString() === filters.animal_id
      );
    }

    // Apply date range filter
    if (filters.date_range) {
      const now = new Date();
      let startDate = new Date();
      
      switch (filters.date_range) {
        case "Last 7 days":
          startDate.setDate(now.getDate() - 7);
          break;
        case "Last 30 days":
          startDate.setDate(now.getDate() - 30);
          break;
        case "Last 90 days":
          startDate.setDate(now.getDate() - 90);
          break;
        case "This year":
          startDate = new Date(now.getFullYear(), 0, 1);
          break;
        default:
          break;
      }
      
      results = results.filter(event => {
        try {
          const eventDate = new Date(event.originalDate || event.date);
          return !isNaN(eventDate.getTime()) && eventDate >= startDate;
        } catch (err) {
          console.error('Error filtering by date:', err);
          return false;
        }
      });
    }

    // Apply sorting
    if (sortConfig.key) {
      results.sort((a, b) => {
        const aVal = a[sortConfig.key];
        const bVal = b[sortConfig.key];
        
        if (aVal === null || aVal === undefined) return 1;
        if (bVal === null || bVal === undefined) return -1;
        
        if (sortConfig.key === 'date') {
          // Sort by date object for proper date comparison
          try {
            const aDate = new Date(a.originalDate || a.date);
            const bDate = new Date(b.originalDate || b.date);
            if (isNaN(aDate.getTime()) || isNaN(bDate.getTime())) return 0;
            return sortConfig.direction === 'asc' ? aDate - bDate : bDate - aDate;
          } catch (err) {
            return 0;
          }
        }
        
        if (typeof aVal === 'string' && typeof bVal === 'string') {
          return sortConfig.direction === 'asc' 
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(aVal);
        }
        
        if (aVal < bVal) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aVal > bVal) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }

    setFilteredEvents(results);
  }, [reproductionEvents, searchTerm, filters, sortConfig, activeTab]);

  // Sort Handler
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // Filter Handlers
  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const resetFilters = () => {
    setFilters({
      event_type: "",
      animal_id: "",
      date_range: ""
    });
    setSearchTerm("");
    setSortConfig({ key: null, direction: 'asc' });
    setActiveTab(0);
  };

  // Form Handlers
  const handleFormChange = (field, value) => {
    setReproductionForm(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const resetForm = () => {
    setReproductionForm({
      animal_id: "",
      event_type: "Heat",
      date: new Date().toISOString().split('T')[0],
      notes: ""
    });
  };

  // Get Event Status
  const getEventStatus = (eventType) => {
    switch (eventType) {
      case "Heat": return "Cycle";
      case "Insemination": return "Breeding";
      case "Pregnancy Check": return "Check";
      default: return "Recorded";
    }
  };

  // Create Reproduction Event
  const handleCreateReproductionEvent = async () => {
    // Validation
    if (!reproductionForm.animal_id || !reproductionForm.event_type) {
      swal("Error", "Animal and event type are required", "error");
      return;
    }

    try {
      const res = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...reproductionForm,
          animal_id: parseInt(reproductionForm.animal_id)
        }),
      });

      const data = await res.json();
      if (res.ok) {
        swal("Success", "Reproduction event recorded successfully!", "success");
        setOpenCreateDialog(false);
        resetForm();
        fetchReproductionEvents();
      } else {
        swal("Error", data.error, "error");
      }
    } catch (err) {
      swal("Error", "Something went wrong", "error");
    }
  };

  // Update Reproduction Event
  const handleUpdateReproductionEvent = async () => {
    if (!selectedEvent) return;

    try {
      const res = await fetch(`${API_URL}/${selectedEvent.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...reproductionForm,
          animal_id: parseInt(reproductionForm.animal_id)
        }),
      });

      const data = await res.json();
      if (res.ok) {
        swal("Success", "Reproduction event updated successfully!", "success");
        setOpenEditDialog(false);
        setSelectedEvent(null);
        resetForm();
        fetchReproductionEvents();
      } else {
        swal("Error", data.error, "error");
      }
    } catch (err) {
      swal("Error", "Something went wrong", "error");
    }
  };

  // Delete Handler
  const handleDelete = async (eventId) => {
    const confirm = await swal({
      title: "Are you sure?",
      text: "This will permanently delete the reproduction event!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (confirm) {
      try {
        const res = await fetch(`${API_URL}/${eventId}`, { method: "DELETE" });
        const data = await res.json();
        if (res.ok) {
          swal("Deleted!", data.message, "success");
          fetchReproductionEvents();
        } else {
          swal("Error", data.error, "error");
        }
      } catch (err) {
        swal("Error", "Something went wrong", "error");
      }
    }
  };

  // View Handler
  const handleView = (event) => {
    setSelectedEvent(event);
    setOpenViewDialog(true);
  };

  // Open Edit Dialog - FIXED VERSION
  const handleEdit = (event) => {
    setSelectedEvent(event);
    
    // Use the helper function to safely format the date
    const formattedDate = formatDateForInput(event.originalDate || event.date);
    
    setReproductionForm({
      animal_id: event.animal_id.toString(),
      event_type: event.event_type,
      date: formattedDate,
      notes: event.notes || ""
    });
    setOpenEditDialog(true);
  };

  // Get Event Type Color
  const getEventTypeColor = (eventType) => {
    switch (eventType) {
      case "Heat": return 'warning';
      case "Insemination": return 'primary';
      case "Pregnancy Check": return 'success';
      default: return 'default';
    }
  };

  // Get Event Type Icon
  const getEventTypeIcon = (eventType) => {
    switch (eventType) {
      case "Heat": return "🔥";
      case "Insemination": return "🔬";
      case "Pregnancy Check": return "🤰";
      default: return "📝";
    }
  };

  // Get Event Type MUI Icon
  const getEventTypeMuiIcon = (eventType) => {
    switch (eventType) {
      case "Heat": return <ReproductionIcon />;
      case "Insemination": return <BiotechIcon />;
      case "Pregnancy Check": return <PregnancyIcon />;
      default: return <EventTypeIcon />;
    }
  };

  // Tab Change Handler
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // Virtualized Table Content
  const fixedHeaderContent = () => (
    <TableRow>
      {columns.map((column) => (
        <TableCell
          key={column.dataKey}
          variant="head"
          align="left"
          style={{ width: column.width }}
          sx={{ 
            backgroundColor: customColors.primary, 
            color: 'white',
            fontWeight: 'bold',
            fontSize: '14px',
            padding: '12px 8px'
          }}
        >
          <TableSortLabel
            active={sortConfig.key === column.dataKey}
            direction={sortConfig.direction}
            onClick={() => handleSort(column.dataKey)}
            sx={{ color: 'white !important' }}
          >
            {column.label}
          </TableSortLabel>
        </TableCell>
      ))}
    </TableRow>
  );

  const rowContent = (index, event) => (
    <React.Fragment>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" fontWeight="bold" noWrap>
          {event.animal_id}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Box>
          <Typography variant="body2" fontWeight="bold" noWrap>
            {event.animal_name}
          </Typography>
          <Typography variant="caption" color="textSecondary" noWrap>
            Tag: {event.animal_tag}
          </Typography>
        </Box>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Chip 
          label={`${getEventTypeIcon(event.event_type)} ${event.event_type}`} 
          size="small"
          color={getEventTypeColor(event.event_type)}
          sx={{ fontSize: '0.7rem', height: '24px' }}
        />
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {event.date}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap title={event.notes}>
          {event.short_notes}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Chip 
          label={event.status} 
          size="small"
          color={getEventTypeColor(event.event_type)}
          variant="outlined"
          sx={{ fontSize: '0.7rem', height: '24px' }}
        />
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'nowrap' }}>
          <IconButton 
            size="small" 
            onClick={() => handleView(event)}
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              backgroundColor: customColors.lightTeal,
              color: customColors.primary,
              '&:hover': { 
                backgroundColor: customColors.primary,
                color: 'white'
              }
            }}
          >
            <ViewIcon fontSize="small" />
          </IconButton>
          <IconButton 
            size="small" 
            onClick={() => handleEdit(event)}
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              backgroundColor: customColors.lightOrange,
              color: customColors.secondary,
              '&:hover': { 
                backgroundColor: customColors.secondary,
                color: 'white'
              }
            }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
          <IconButton 
            size="small" 
            onClick={() => handleDelete(event.id)}
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              backgroundColor: 'rgba(211, 47, 47, 0.1)',
              color: 'error.main',
              '&:hover': { 
                backgroundColor: 'error.main',
                color: 'white'
              }
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      </TableCell>
    </React.Fragment>
  );

  return (
    <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
      {/* Header */}
      <AppBar position="static" elevation={2} sx={{ backgroundColor: customColors.primary }}>
        <Toolbar>
          <ReproductionIcon sx={{ mr: 2, fontSize: 32 }} />
          <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
            Reproduction Events
          </Typography>
          <Chip 
            label={`${reproductionEvents.length} Events`} 
            sx={{ 
              backgroundColor: customColors.secondary, 
              color: 'white', 
              fontWeight: 'bold', 
              mr: 2 
            }}
          />
          <Button 
            variant="contained" 
            startIcon={<AddIcon sx={{ fontSize: 24 }} />}
            onClick={() => setOpenCreateDialog(true)}
            sx={{ 
              borderRadius: 2, 
              backgroundColor: customColors.secondary,
              '&:hover': {
                backgroundColor: '#e69900',
                transform: 'translateY(-2px)',
                boxShadow: 4
              },
              transition: 'all 0.3s ease',
              fontWeight: 'bold',
              fontSize: '1rem',
              px: 3,
              py: 1.5
            }}
          >
            New Event
          </Button>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Box sx={{ p: 3 }}>
        <Paper sx={{ 
          mb: 3, 
          borderRadius: 2, 
          border: 2, 
          borderColor: customColors.lightTeal,
          backgroundColor: customColors.lightTeal
        }}>
          {/* Event Type Tabs */}
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs 
              value={activeTab} 
              onChange={handleTabChange} 
              variant="scrollable" 
              scrollButtons="auto"
              sx={{
                '& .MuiTab-root': {
                  color: customColors.primary,
                  '&.Mui-selected': {
                    color: customColors.primary,
                    fontWeight: 'bold'
                  }
                },
                '& .MuiTabs-indicator': {
                  backgroundColor: customColors.secondary
                }
              }}
            >
              <Tab label="All Events" />
              <Tab label="Heat" icon={<span>🔥</span>} iconPosition="start" />
              <Tab label="Insemination" icon={<span>🔬</span>} iconPosition="start" />
              <Tab label="Pregnancy Check" icon={<span>🤰</span>} iconPosition="start" />
            </Tabs>
          </Box>

          {/* Search and Filters */}
          <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  placeholder="Search by cow name, tag, notes, event type..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: 'white',
                      '&:hover fieldset': {
                        borderColor: customColors.primary,
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: customColors.primary,
                      },
                    }
                  }}
                  InputProps={{
                    startAdornment: <SearchIcon sx={{ color: customColors.primary, mr: 1, fontSize: 24 }} />,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                  <Button
                    startIcon={<FilterIcon sx={{ fontSize: 20 }} />}
                    onClick={() => setShowFilters(!showFilters)}
                    variant={showFilters ? "contained" : "outlined"}
                    size="small"
                    sx={{
                      backgroundColor: showFilters ? customColors.primary : 'transparent',
                      color: showFilters ? 'white' : customColors.primary,
                      borderColor: customColors.primary,
                      '&:hover': {
                        backgroundColor: showFilters ? '#023a47' : customColors.lightOrange,
                        borderColor: customColors.primary
                      }
                    }}
                  >
                    Filters
                  </Button>
                  <Button 
                    onClick={resetFilters} 
                    variant="outlined" 
                    size="small" 
                    sx={{
                      color: customColors.primary,
                      borderColor: customColors.primary,
                      '&:hover': {
                        backgroundColor: customColors.lightOrange,
                        borderColor: customColors.primary
                      }
                    }}
                  >
                    Reset
                  </Button>
                  <Button 
                    onClick={fetchReproductionEvents} 
                    variant="contained" 
                    size="small" 
                    startIcon={<TimelineIcon sx={{ fontSize: 20 }} />}
                    sx={{
                      backgroundColor: customColors.primary,
                      '&:hover': {
                        backgroundColor: '#023a47'
                      }
                    }}
                  >
                    Refresh
                  </Button>
                </Box>
              </Grid>
            </Grid>

            {/* Expandable Filters */}
            {showFilters && (
              <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Event Type</InputLabel>
                      <Select
                        value={filters.event_type}
                        onChange={(e) => handleFilterChange('event_type', e.target.value)}
                        label="Event Type"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            '&:hover fieldset': {
                              borderColor: customColors.primary,
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: customColors.primary,
                            },
                          }
                        }}
                      >
                        <MenuItem value="">All Event Types</MenuItem>
                        {eventTypeOptions.map(type => (
                          <MenuItem key={type} value={type}>
                            {type}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Cow</InputLabel>
                      <Select
                        value={filters.animal_id}
                        onChange={(e) => handleFilterChange('animal_id', e.target.value)}
                        label="Cow"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            '&:hover fieldset': {
                              borderColor: customColors.primary,
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: customColors.primary,
                            },
                          }
                        }}
                      >
                        <MenuItem value="">All Cows</MenuItem>
                        {animals.map(animal => (
                          <MenuItem key={animal.id} value={animal.id.toString()}>
                            {animal.name || `Cow ${animal.id}`} ({animal.tag_number})
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Date Range</InputLabel>
                      <Select
                        value={filters.date_range}
                        onChange={(e) => handleFilterChange('date_range', e.target.value)}
                        label="Date Range"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            '&:hover fieldset': {
                              borderColor: customColors.primary,
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: customColors.primary,
                            },
                          }
                        }}
                      >
                        <MenuItem value="">All Dates</MenuItem>
                        {dateRangeOptions.map(range => (
                          <MenuItem key={range} value={range}>
                            {range}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Box>
            )}
          </Box>

          {/* Content Area */}
          <Box sx={{ p: 2 }}>
            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                <CircularProgress sx={{ color: customColors.primary }} size={40} />
              </Box>
            ) : filteredEvents.length === 0 ? (
              <Card sx={{ 
                textAlign: 'center', 
                p: 4, 
                border: 2, 
                borderColor: customColors.lightTeal,
                backgroundColor: 'white'
              }}>
                <CardContent>
                  <TimelineIcon sx={{ fontSize: 64, color: customColors.primary, mb: 2 }} />
                  <Typography variant="h5" sx={{ color: customColors.primary, mb: 1 }}>
                    {animals.length === 0 ? "No Cows Available" : "No Reproduction Events Found"}
                  </Typography>
                  <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
                    {animals.length === 0 
                      ? "No cows found in the system. Please add cows first to record reproduction events."
                      : "Start tracking your herd's reproduction cycle to optimize breeding and improve productivity"
                    }
                  </Typography>
                  <Button 
                    variant="contained" 
                    onClick={() => setOpenCreateDialog(true)} 
                    size="large"
                    startIcon={<AddIcon sx={{ fontSize: 24 }} />}
                    sx={{ 
                      borderRadius: 2,
                      backgroundColor: customColors.secondary,
                      '&:hover': {
                        backgroundColor: '#e69900'
                      }
                    }}
                    disabled={animals.length === 0}
                  >
                    {animals.length === 0 ? "Add Cows First" : "Record First Event"}
                  </Button>
                </CardContent>
              </Card>
            ) : (
              <Paper elevation={0} sx={{ 
                height: 600, 
                border: 1, 
                borderColor: customColors.lightTeal, 
                borderRadius: 1 
              }}>
                <TableVirtuoso
                  data={filteredEvents}
                  components={VirtuosoTableComponents}
                  fixedHeaderContent={fixedHeaderContent}
                  itemContent={rowContent}
                />
              </Paper>
            )}
          </Box>
        </Paper>
      </Box>

      {/* Create Reproduction Event Dialog - REDESIGNED */}
      <Dialog 
        open={openCreateDialog} 
        onClose={() => setOpenCreateDialog(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{ 
          sx: { 
            borderRadius: 3,
            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
            boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
          } 
        }}
      >
        <DialogTitle sx={{ 
          backgroundColor: customColors.primary, 
          color: 'white',
          background: `linear-gradient(135deg, ${customColors.primary} 0%, #023a47 100%)`,
          py: 3,
          position: 'relative',
          overflow: 'hidden'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative', zIndex: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Avatar sx={{ backgroundColor: 'rgba(255,255,255,0.2)', width: 48, height: 48 }}>
                <AddIcon sx={{ fontSize: 28 }} />
              </Avatar>
              <Box>
                <Typography variant="h5" fontWeight="bold">
                  Record New Reproduction Event
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
                  Track breeding cycles and reproductive health
                </Typography>
              </Box>
            </Box>
            <IconButton 
              onClick={() => setOpenCreateDialog(false)} 
              sx={{ 
                color: 'white',
                backgroundColor: 'rgba(255,255,255,0.2)',
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.3)' }
              }}
            >
              <CloseIcon sx={{ fontSize: 24 }} />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ p: 0 }}>
          {/* Stepper for better UX */}
          <Box sx={{ px: 4, pt: 3, pb: 2 }}>
            <Stepper activeStep={0} alternativeLabel>
              <Step>
                <StepLabel>Event Details</StepLabel>
              </Step>
              <Step>
                <StepLabel>Animal Selection</StepLabel>
              </Step>
              <Step>
                <StepLabel>Confirmation</StepLabel>
              </Step>
            </Stepper>
          </Box>

          <Divider />

          <Box sx={{ p: 4 }}>
            <Grid container spacing={4}>
              {/* Animal Selection Section */}
              <Grid item xs={12}>
                <Card variant="outlined" sx={{ borderRadius: 2, borderColor: customColors.lightTeal, backgroundColor: 'rgba(2, 74, 89, 0.02)' }}>
                  <CardContent sx={{ p: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                      <AnimalIcon sx={{ mr: 2, fontSize: 28, color: customColors.primary }} />
                      <Typography variant="h6" sx={{ color: customColors.primary }} fontWeight="bold">
                        Select Animal
                      </Typography>
                    </Box>
                    <FormControl fullWidth size="large">
                      <InputLabel id="animal-label" sx={{ fontWeight: 'bold' }}>
                        🐄 Choose Cow *
                      </InputLabel>
                      <Select
                        labelId="animal-label"
                        value={reproductionForm.animal_id}
                        onChange={(e) => handleFormChange('animal_id', e.target.value)}
                        label="🐄 Choose Cow *"
                        disabled={animals.length === 0}
                        sx={{
                          '& .MuiSelect-select': {
                            py: 2.5,
                            fontSize: '1rem'
                          },
                          '& .MuiOutlinedInput-root': {
                            '&:hover fieldset': {
                              borderColor: customColors.primary,
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: customColors.primary,
                            },
                          }
                        }}
                      >
                        {animals.map(animal => (
                          <MenuItem key={animal.id} value={animal.id.toString()} sx={{ py: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                              <Avatar sx={{ backgroundColor: customColors.primary, width: 40, height: 40 }}>
                                <AnimalIcon sx={{ fontSize: 20 }} />
                              </Avatar>
                              <Box sx={{ flexGrow: 1 }}>
                                <Typography variant="body1" fontWeight="bold">
                                  {animal.name || `Cow ${animal.id}`}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                  <TagIcon sx={{ fontSize: 14, mr: 0.5 }} />
                                  Tag: {animal.tag_number} • ID: {animal.id}
                                </Typography>
                              </Box>
                              {animal.breed && (
                                <Chip 
                                  label={animal.breed} 
                                  size="small" 
                                  variant="outlined" 
                                  sx={{
                                    borderColor: customColors.secondary,
                                    color: customColors.secondary
                                  }}
                                />
                              )}
                            </Box>
                          </MenuItem>
                        ))}
                      </Select>
                      {animals.length === 0 && (
                        <Alert severity="warning" sx={{ mt: 2, borderRadius: 2 }}>
                          <Typography fontWeight="bold">No cows available</Typography>
                          Please add cows first to record reproduction events.
                        </Alert>
                      )}
                    </FormControl>
                  </CardContent>
                </Card>
              </Grid>

              {/* Event Details Section */}
              <Grid item xs={12}>
                <Card variant="outlined" sx={{ borderRadius: 2, borderColor: customColors.lightTeal, backgroundColor: 'rgba(255, 169, 22, 0.02)' }}>
                  <CardContent sx={{ p: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                      <EventTypeIcon sx={{ mr: 2, fontSize: 28, color: customColors.secondary }} />
                      <Typography variant="h6" sx={{ color: customColors.secondary }} fontWeight="bold">
                        Event Details
                      </Typography>
                    </Box>
                    
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6}>
                        <FormControl fullWidth size="large">
                          <InputLabel id="event-type-label" sx={{ fontWeight: 'bold' }}>
                            📋 Event Type *
                          </InputLabel>
                          <Select
                            labelId="event-type-label"
                            value={reproductionForm.event_type}
                            onChange={(e) => handleFormChange('event_type', e.target.value)}
                            label="📋 Event Type *"
                            sx={{
                              '& .MuiSelect-select': {
                                py: 2.5,
                                fontSize: '1rem'
                              },
                              '& .MuiOutlinedInput-root': {
                                '&:hover fieldset': {
                                  borderColor: customColors.primary,
                                },
                                '&.Mui-focused fieldset': {
                                  borderColor: customColors.primary,
                                },
                              }
                            }}
                          >
                            {eventTypeOptions.map(type => (
                              <MenuItem key={type} value={type} sx={{ py: 2 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                  <Avatar 
                                    sx={{ 
                                      backgroundColor: getEventTypeColor(type) === 'primary' ? customColors.primary : 
                                                     getEventTypeColor(type) === 'secondary' ? customColors.secondary : 
                                                     getEventTypeColor(type) + '.main',
                                      width: 36, 
                                      height: 36 
                                    }}
                                  >
                                    {getEventTypeMuiIcon(type)}
                                  </Avatar>
                                  <Box>
                                    <Typography variant="body1" fontWeight="bold">
                                      {type}
                                    </Typography>
                                    <Typography variant="caption" color="textSecondary">
                                      {type === "Heat" && "Heat cycle detection"}
                                      {type === "Insemination" && "Artificial insemination"}
                                      {type === "Pregnancy Check" && "Pregnancy verification"}
                                    </Typography>
                                  </Box>
                                </Box>
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          size="large"
                          label={
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <CalendarIcon color="action" />
                              <span>Event Date *</span>
                            </Box>
                          }
                          type="date"
                          value={reproductionForm.date}
                          onChange={(e) => handleFormChange('date', e.target.value)}
                          InputLabelProps={{ shrink: true }}
                          InputProps={{
                            sx: {
                              py: 2.5,
                              fontSize: '1rem'
                            }
                          }}
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              '&:hover fieldset': {
                                borderColor: customColors.primary,
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: customColors.primary,
                              },
                            }
                          }}
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              {/* Notes Section */}
              <Grid item xs={12}>
                <Card variant="outlined" sx={{ borderRadius: 2, borderColor: customColors.lightTeal, backgroundColor: 'rgba(76, 175, 80, 0.02)' }}>
                  <CardContent sx={{ p: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                      <NotesIcon sx={{ mr: 2, fontSize: 28, color: 'success.main' }} />
                      <Typography variant="h6" color="success.main" fontWeight="bold">
                        Additional Notes
                      </Typography>
                    </Box>
                    <TextField
                      fullWidth
                      multiline
                      rows={4}
                      placeholder="📝 Record important observations, procedures performed, medications used, or any other relevant details about this reproduction event..."
                      value={reproductionForm.notes}
                      onChange={(e) => handleFormChange('notes', e.target.value)}
                      helperText="Detailed notes help in tracking reproductive health and making informed breeding decisions"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          fontSize: '1rem',
                          lineHeight: 1.5,
                          '&:hover fieldset': {
                            borderColor: customColors.primary,
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: customColors.primary,
                          },
                        }
                      }}
                    />
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>

        <DialogActions sx={{ p: 4, pt: 2, gap: 2 }}>
          <Button 
            onClick={() => setOpenCreateDialog(false)} 
            size="large"
            variant="outlined"
            sx={{ 
              minWidth: 120,
              borderRadius: 2,
              py: 1.5,
              borderWidth: 2,
              color: customColors.primary,
              borderColor: customColors.primary,
              '&:hover': { 
                borderWidth: 2,
                backgroundColor: customColors.lightOrange
              }
            }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleCreateReproductionEvent} 
            variant="contained" 
            size="large"
            disabled={!reproductionForm.animal_id || !reproductionForm.event_type || animals.length === 0}
            sx={{ 
              minWidth: 180,
              borderRadius: 2,
              py: 1.5,
              fontSize: '1.1rem',
              fontWeight: 'bold',
              backgroundColor: customColors.secondary,
              boxShadow: '0 4px 15px rgba(255, 169, 22, 0.3)',
              '&:hover': {
                backgroundColor: '#e69900',
                boxShadow: '0 6px 20px rgba(255, 169, 22, 0.4)',
                transform: 'translateY(-2px)'
              },
              transition: 'all 0.3s ease'
            }}
          >
            <AddIcon sx={{ mr: 1, fontSize: 24 }} />
            Record Event
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Reproduction Event Dialog - REDESIGNED */}
      <Dialog 
        open={openEditDialog} 
        onClose={() => setOpenEditDialog(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{ 
          sx: { 
            borderRadius: 3,
            background: 'linear-gradient(135deg, #fffde7 0%, #f5f7fa 100%)',
            boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
          } 
        }}
      >
        <DialogTitle sx={{ 
          backgroundColor: customColors.primary, 
          color: 'white',
          background: `linear-gradient(135deg, ${customColors.primary} 0%, #023a47 100%)`,
          py: 3,
          position: 'relative',
          overflow: 'hidden'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative', zIndex: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Avatar sx={{ backgroundColor: 'rgba(255,255,255,0.2)', width: 48, height: 48 }}>
                <EditIcon sx={{ fontSize: 28 }} />
              </Avatar>
              <Box>
                <Typography variant="h5" fontWeight="bold">
                  Update Reproduction Event
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
                  Modify event details and notes
                </Typography>
              </Box>
            </Box>
            <IconButton 
              onClick={() => setOpenEditDialog(false)} 
              sx={{ 
                color: 'white',
                backgroundColor: 'rgba(255,255,255,0.2)',
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.3)' }
              }}
            >
              <CloseIcon sx={{ fontSize: 24 }} />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ p: 4 }}>
          <Grid container spacing={4}>
            {/* Animal Selection Section */}
            <Grid item xs={12}>
              <Card variant="outlined" sx={{ borderRadius: 2, borderColor: customColors.lightTeal, backgroundColor: 'rgba(2, 74, 89, 0.02)' }}>
                <CardContent sx={{ p: 3 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <AnimalIcon sx={{ mr: 2, fontSize: 28, color: customColors.primary }} />
                    <Typography variant="h6" sx={{ color: customColors.primary }} fontWeight="bold">
                      Animal Information
                    </Typography>
                  </Box>
                  <FormControl fullWidth size="large">
                    <InputLabel id="edit-animal-label" sx={{ fontWeight: 'bold' }}>
                      🐄 Select Cow *
                    </InputLabel>
                    <Select
                      labelId="edit-animal-label"
                      value={reproductionForm.animal_id}
                      onChange={(e) => handleFormChange('animal_id', e.target.value)}
                      label="🐄 Select Cow *"
                      sx={{
                        '& .MuiSelect-select': {
                          py: 2.5,
                          fontSize: '1rem'
                        },
                        '& .MuiOutlinedInput-root': {
                          '&:hover fieldset': {
                            borderColor: customColors.primary,
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: customColors.primary,
                          },
                        }
                      }}
                    >
                      {animals.map(animal => (
                        <MenuItem key={animal.id} value={animal.id.toString()} sx={{ py: 2 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                            <Avatar sx={{ backgroundColor: customColors.primary, width: 40, height: 40 }}>
                              <AnimalIcon sx={{ fontSize: 20 }} />
                            </Avatar>
                            <Box sx={{ flexGrow: 1 }}>
                              <Typography variant="body1" fontWeight="bold">
                                {animal.name || `Cow ${animal.id}`}
                              </Typography>
                              <Typography variant="body2" color="textSecondary">
                                <TagIcon sx={{ fontSize: 14, mr: 0.5 }} />
                                Tag: {animal.tag_number} • ID: {animal.id}
                              </Typography>
                            </Box>
                            {animal.breed && (
                              <Chip 
                                label={animal.breed} 
                                size="small" 
                                variant="outlined" 
                                sx={{
                                  borderColor: customColors.secondary,
                                  color: customColors.secondary
                                }}
                              />
                            )}
                          </Box>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </CardContent>
              </Card>
            </Grid>

            {/* Event Details Section */}
            <Grid item xs={12}>
              <Card variant="outlined" sx={{ borderRadius: 2, borderColor: customColors.lightTeal, backgroundColor: 'rgba(255, 169, 22, 0.02)' }}>
                <CardContent sx={{ p: 3 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <EventTypeIcon sx={{ mr: 2, fontSize: 28, color: customColors.secondary }} />
                    <Typography variant="h6" sx={{ color: customColors.secondary }} fontWeight="bold">
                      Event Details
                    </Typography>
                  </Box>
                  
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth size="large">
                        <InputLabel id="edit-event-type-label" sx={{ fontWeight: 'bold' }}>
                          📋 Event Type *
                        </InputLabel>
                        <Select
                          labelId="edit-event-type-label"
                          value={reproductionForm.event_type}
                          onChange={(e) => handleFormChange('event_type', e.target.value)}
                          label="📋 Event Type *"
                          sx={{
                            '& .MuiSelect-select': {
                              py: 2.5,
                              fontSize: '1rem'
                            },
                            '& .MuiOutlinedInput-root': {
                              '&:hover fieldset': {
                                borderColor: customColors.primary,
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: customColors.primary,
                              },
                            }
                          }}
                        >
                          {eventTypeOptions.map(type => (
                            <MenuItem key={type} value={type} sx={{ py: 2 }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Avatar 
                                  sx={{ 
                                    backgroundColor: getEventTypeColor(type) === 'primary' ? customColors.primary : 
                                                   getEventTypeColor(type) === 'secondary' ? customColors.secondary : 
                                                   getEventTypeColor(type) + '.main',
                                    width: 36, 
                                    height: 36 
                                  }}
                                >
                                  {getEventTypeMuiIcon(type)}
                                </Avatar>
                                <Box>
                                  <Typography variant="body1" fontWeight="bold">
                                    {type}
                                  </Typography>
                                  <Typography variant="caption" color="textSecondary">
                                    {type === "Heat" && "Heat cycle detection"}
                                    {type === "Insemination" && "Artificial insemination"}
                                    {type === "Pregnancy Check" && "Pregnancy verification"}
                                  </Typography>
                                </Box>
                              </Box>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        size="large"
                        label={
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <CalendarIcon color="action" />
                            <span>Event Date *</span>
                          </Box>
                        }
                        type="date"
                        value={reproductionForm.date}
                        onChange={(e) => handleFormChange('date', e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          sx: {
                            py: 2.5,
                            fontSize: '1rem'
                          }
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            '&:hover fieldset': {
                              borderColor: customColors.primary,
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: customColors.primary,
                            },
                          }
                        }}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            {/* Notes Section */}
            <Grid item xs={12}>
              <Card variant="outlined" sx={{ borderRadius: 2, borderColor: customColors.lightTeal, backgroundColor: 'rgba(76, 175, 80, 0.02)' }}>
                <CardContent sx={{ p: 3 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <NotesIcon sx={{ mr: 2, fontSize: 28, color: 'success.main' }} />
                    <Typography variant="h6" color="success.main" fontWeight="bold">
                      Additional Notes
                    </Typography>
                  </Box>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    placeholder="📝 Update observations, procedures, medications, or any relevant details..."
                    value={reproductionForm.notes}
                    onChange={(e) => handleFormChange('notes', e.target.value)}
                    helperText="Keep notes updated for accurate reproductive health tracking"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        fontSize: '1rem',
                        lineHeight: 1.5,
                        '&:hover fieldset': {
                          borderColor: customColors.primary,
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: customColors.primary,
                        },
                      }
                    }}
                  />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ p: 4, pt: 2, gap: 2 }}>
          <Button 
            onClick={() => setOpenEditDialog(false)} 
            size="large"
            variant="outlined"
            sx={{ 
              minWidth: 120,
              borderRadius: 2,
              py: 1.5,
              borderWidth: 2,
              color: customColors.primary,
              borderColor: customColors.primary,
              '&:hover': { 
                borderWidth: 2,
                backgroundColor: customColors.lightOrange
              }
            }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleUpdateReproductionEvent} 
            variant="contained" 
            size="large"
            disabled={!reproductionForm.animal_id || !reproductionForm.event_type}
            sx={{ 
              minWidth: 200,
              borderRadius: 2,
              py: 1.5,
              fontSize: '1.1rem',
              fontWeight: 'bold',
              backgroundColor: customColors.primary,
              boxShadow: '0 4px 15px rgba(2, 74, 89, 0.3)',
              '&:hover': {
                backgroundColor: '#023a47',
                boxShadow: '0 6px 20px rgba(2, 74, 89, 0.4)',
                transform: 'translateY(-2px)'
              },
              transition: 'all 0.3s ease'
            }}
          >
            <EditIcon sx={{ mr: 1, fontSize: 24 }} />
            Update Event
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Reproduction Event Dialog */}
      <Dialog 
        open={openViewDialog} 
        onClose={() => setOpenViewDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ backgroundColor: customColors.primary, color: 'white' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ViewIcon sx={{ mr: 1, fontSize: 28 }} />
              <Typography variant="h6">Reproduction Event Details</Typography>
            </Box>
            <IconButton 
              onClick={() => setOpenViewDialog(false)}
              sx={{ color: 'white' }}
            >
              <CloseIcon sx={{ fontSize: 24 }} />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          {selectedEvent && (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Card variant="outlined" sx={{ borderColor: customColors.lightTeal }}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ color: customColors.primary }}>
                      Animal Information
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Animal ID:</strong> {selectedEvent.animal_id}
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Animal Name:</strong> {selectedEvent.animal_name}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Tag Number:</strong> {selectedEvent.animal_tag}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Card variant="outlined" sx={{ borderColor: customColors.lightTeal }}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ color: customColors.primary }}>
                      Event Details
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Event Type:</strong> 
                      <Chip 
                        label={`${getEventTypeIcon(selectedEvent.event_type)} ${selectedEvent.event_type}`} 
                        size="small"
                        color={getEventTypeColor(selectedEvent.event_type)}
                        sx={{ ml: 1 }}
                      />
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Date:</strong> {selectedEvent.date}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Status:</strong> {selectedEvent.status}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12}>
                <Card variant="outlined" sx={{ borderColor: customColors.lightTeal }}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ color: customColors.primary }}>
                      Event Notes
                    </Typography>
                    <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                      {selectedEvent.notes || 'No notes recorded for this event.'}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => setOpenViewDialog(false)}
            sx={{ color: customColors.primary }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add FAB for mobile */}
      <Fab
        aria-label="add"
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          display: { xs: 'flex', md: 'none' },
          backgroundColor: customColors.secondary,
          color: 'white',
          '&:hover': {
            backgroundColor: '#e69900'
          }
        }}
        onClick={() => setOpenCreateDialog(true)}
        disabled={animals.length === 0}
      >
        <AddIcon />
      </Fab>
    </Box>
  );
};

export default ReproductionEventsPage;